// src/graphql/rbac.js
import { gql } from "@apollo/client";

export const GET_ROLES = gql`
  query GetRoles {
    getRoles {
      roles {
        id
        name
        description
      }
    }
  }
`;

export const ADD_ROLE = gql`
  mutation AddRole($data: AddRoleInput!) {
    addRole(data: $data) {
      status
      message
    }
  }
`;

export const DELETE_ROLE = gql`
  mutation DeleteRole($data: DeleteByIdInput!) {
    deleteRole(data: $data) {
      status
      message
    }
  }
`;

/* Permissions */
export const GET_PERMISSIONS = gql`
  query GetPermissions {
    getPermissions {
      permissions {
        id
        code
        description
      }
    }
  }
`;

export const ADD_PERMISSION = gql`
  mutation AddPermission($data: AddPermissionInput!) {
    addPermission(data: $data) {
      status
      message
    }
  }
`;

export const DELETE_PERMISSION = gql`
  mutation DeletePermission($data: DeleteByIdInput!) {
    deletePermission(data: $data) {
      status
      message
    }
  }
`;

/* Role <-> Permission */
export const GET_ROLE_PERMISSIONS = gql`
  query GetRolePermissions($data: GetRolePermissionsInput) {
    getRolePermissions(data: $data) {
      permissions {
        id
        code
        description
      }
    }
  }
`;

export const ADD_ROLE_PERMISSION = gql`
  mutation AddRolePermission($data: AddRolePermissionInput!) {
    addRolePermission(data: $data) {
      status
      message
    }
  }
`;

export const DELETE_ROLE_PERMISSION = gql`
  mutation DeleteRolePermission($data: DeleteRolePermissionInput!) {
    deleteRolePermission(data: $data) {
      status
      message
    }
  }
`;

/* Admin <-> Role */
export const GET_ADMIN_ROLES = gql`
  query GetAdminRoles($data: GetAdminRolesInput) {
    getAdminRoles(data: $data) {
      admins {
        id
        fullName
        roles {
          id
          name
        }
      }
      roles {
        id
        name
      }
    }
  }
`;

export const ADD_ADMIN_ROLE = gql`
  mutation AddAdminRole($data: AddAdminRoleInput!) {
    addAdminRole(data: $data) {
      status
      message
    }
  }
`;

export const DELETE_ADMIN_ROLE = gql`
  mutation DeleteAdminRole($data: DeleteAdminRoleInput!) {
    deleteAdminRole(data: $data) {
      status
      message
    }
  }
`;
